module.exports = __webpack_public_path__ + "static/media/loginBg.af0470f9.png";